// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
// import { AiOutlineFile, AiOutlineLock, AiOutlineMail, AiOutlinePhone, AiOutlineUser, } from 'react-icons/ai';
// import { Link, useNavigate } from 'react-router-dom';
// import A1 from '../Images/elo.png';

// const Signup = () => {
//   const [formData, setFormData] = useState({
//     username: '',
//     mobile: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     company_name: '',
//     company_logo: null,
//   });

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
//   const navigate = useNavigate();

//   // Detect screen width changes
//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 600);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === 'company_logo') {
//       setFormData({ ...formData, [name]: files[0] });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const {
//       username,
//       email,
//       password,
//       confirmPassword,
//       mobile,
//       company_logo,
//       company_name,
//     } = formData;

//     if (password !== confirmPassword) {
//       alert("Passwords don't match!");
//       return;
//     }

//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append('username', username);
//       formDataToSend.append('mobile', mobile);
//       formDataToSend.append('email', email);
//       formDataToSend.append('password', password);
//       formDataToSend.append('company_name', company_name);
//       if (company_logo) {
//         formDataToSend.append('company_logo', company_logo);
//       }

//       const response = await axios.post('https://cloudapi.emedhatechnologies.com/auth/api/Signup',
//         formDataToSend,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         }
//       );

//       if (response.status === 200) {
//         alert(response.data.message);
//         navigate('/verification');
//         setFormData({
//           username: '',
//           mobile: '',
//           email: '',
//           password: '',
//           confirmPassword: '',
//           company_logo: null,
//           company_name: '',
//         });
//       } else {
//         alert('Failed to register user. Please try again.');
//       }
//     } catch (error) {
//       if (error.response) {
//         console.error('Response error:', error.response);
//         alert(error.response.data.error);
//       } else if (error.request) {
//         console.error('Request error:', error.request);
//         alert('Failed to send request to server.');
//       } else {
//         console.error('Error:', error.message);
//         alert('Something went wrong. Please try again.');
//       }
//     }
//   };

//   const sharedInputStyle = { width: '100%', padding: '10px 10px 10px 40px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '12px', fontFamily: '"Courier New", Courier, monospace', boxSizing: 'border-box', backgroundColor: '#fdfdfd', };
//   const iconStyle = { position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', fontSize: '16px', color: '#888', };

//   return (
//     <div style={{ maxWidth: '700px', margin: 'auto', padding: '20px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '10px', marginTop: '50px', fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif', color: '#333', }}>
//       <img src={A1} alt='Logo' style={{ height: '40px', marginBottom: '20px' }} />
//       <h1 style={{ textAlign: 'center', fontSize: '32px', fontFamily: '"Trebuchet MS", sans-serif', marginBottom: '30px', }}>
//         <strong>Create an account</strong>
//       </h1>

//       <form onSubmit={handleSubmit} style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', }}>
//         {[
//           { icon: <AiOutlineUser />, name: 'username', placeholder: 'Username' },
//           { icon: <AiOutlinePhone />, name: 'mobile', placeholder: 'Mobile', type: 'number' },
//           { icon: <AiOutlineMail />, name: 'email', placeholder: 'Email', type: 'email' },
//           { icon: <AiOutlineLock />, name: 'password', placeholder: 'Password', type: 'password' },
//           {
//             icon: <AiOutlineLock />,
//             name: 'confirmPassword',
//             placeholder: 'Confirm Password',
//             type: 'password',
//           },
//           {
//             icon: <AiOutlineUser />,
//             name: 'company_name',
//             placeholder: 'Company Name',
//           },
//         ].map(({ icon, name, placeholder, type = 'text' }) => (
//           <div key={name} style={{ flex: isMobile ? '1 1 100%' : '1 1 45%', position: 'relative', }}>
//             <div style={iconStyle}>{icon}</div>
//             <input type={type} name={name} placeholder={placeholder} value={formData[name]} onChange={handleChange} required style={sharedInputStyle} />
//           </div>
//         ))}

//         <div style={{ flex: isMobile ? '1 1 100%' : '1 1 45%', position: 'relative' }}>
//           <div style={iconStyle}>
//             <AiOutlineFile />
//           </div>
//           <input type='file' name='company_logo' onChange={handleChange} required style={sharedInputStyle} />
//         </div>

//         <div style={{ flex: '1 1 100%' }}>
//           <ReCAPTCHA sitekey='YOUR_RECAPTCHA_SITE_KEY' />
//         </div>

//         <div style={{ flex: '1 1 100%' }}>
//           <button type='submit' style={{ width: '100%', padding: '10px', backgroundColor: '#07526f', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', fontFamily: '"Verdana", sans-serif', }}>
//             Sign Up
//           </button>
//         </div>
//       </form>

//       <div style={{ textAlign: 'center', marginTop: '20px' }}>
//         <hr style={{ width: '100px', display: 'inline-block' }} />
//         <span style={{ margin: '0 10px' }}>or</span>
//         <hr style={{ width: '100px', display: 'inline-block' }} />
//       </div>

//       <div style={{ textAlign: 'center', marginTop: '10px' }}>
//         <Link to='/' style={{ textDecoration: 'none', color: '#07526f' }}>
//           <span style={{ fontWeight: 'bold' }}>Already have an account?</span>{' '}
//           <AiOutlineUser /> Login
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default Signup;


// import React, { useState } from "react";
// import {
//   Cloud,
//   Mail,
//   Lock,
//   User,
//   Building,
//   Eye,
//   EyeOff,
//   ArrowRight,
// } from "lucide-react";

// function SignupScreen({ onSignup, onSwitchToLogin }) {
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     company: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirmPassword) {
//       alert("PASSWORDS DO NOT MATCH");
//       return;
//     }

//     onSignup();
//   };

//   const handleChange = (field, value) => {
//     setFormData({
//       ...formData,
//       [field]: value,
//     });
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         width: "100%",
//         backgroundColor: "#f8fafc",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "space-between",
//         padding: "24px",
//         fontFamily: "monospace",
//         color: "#0f172a",
//         overflowY: "auto",
//         boxSizing: "border-box",
//       }}
//     >
//       {/* Header */}
//       <header
//         style={{
//           width: "100%",
//           maxWidth: "1280px",
//           margin: "0 auto",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           borderBottom: "1px solid #e2e8f0",
//           paddingBottom: "24px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "12px",
//           }}
//         >
//           <div
//             style={{
//               width: "36px",
//               height: "36px",
//               borderRadius: "8px",
//               backgroundColor: "#000",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <Cloud size={20} color="#fff" />
//           </div>

//           <span
//             style={{
//               fontWeight: "bold",
//               fontSize: "12px",
//               textTransform: "uppercase",
//               letterSpacing: "2px",
//             }}
//           >
//             Cloud Connect
//           </span>
//         </div>

//         <div
//           style={{
//             fontSize: "12px",
//             textTransform: "uppercase",
//           }}
//         >
//           <span
//             style={{
//               color: "#94a3b8",
//               marginRight: "5px",
//             }}
//           >
//             Have an account?
//           </span>

//           <button
//             onClick={onSwitchToLogin}
//             style={{
//               border: "none",
//               background: "transparent",
//               fontWeight: "bold",
//               cursor: "pointer",
//               color: "#000",
//             }}
//           >
//             Sign In
//           </button>
//         </div>
//       </header>

//       {/* Main Form */}
//       <main
//         style={{
//           width: "100%",
//           maxWidth: "400px",
//           margin: "40px auto",
//         }}
//       >
//         <div style={{ marginBottom: "32px" }}>
//           <h1
//             style={{
//               fontSize: "20px",
//               fontWeight: "bold",
//               textTransform: "uppercase",
//               letterSpacing: "2px",
//               marginBottom: "8px",
//             }}
//           >
//             Create Account
//           </h1>

//           <p
//             style={{
//               color: "#94a3b8",
//               fontSize: "12px",
//               textTransform: "uppercase",
//               letterSpacing: "1px",
//             }}
//           >
//             Begin Node Infrastructure Setup
//           </p>
//         </div>

//         <form onSubmit={handleSubmit}>
//           {/* Full Name */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "8px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 color: "#64748b",
//                 textTransform: "uppercase",
//               }}
//             >
//               Full Name
//             </label>

//             <div
//               style={{
//                 position: "relative",
//               }}
//             >
//               <User
//                 size={16}
//                 color="#94a3b8"
//                 style={{
//                   position: "absolute",
//                   left: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                 }}
//               />

//               <input
//                 type="text"
//                 value={formData.fullName}
//                 onChange={(e) =>
//                   handleChange("fullName", e.target.value)
//                 }
//                 placeholder="John Doe"
//                 required
//                 style={{
//                   width: "100%",
//                   height: "44px",
//                   paddingLeft: "40px",
//                   paddingRight: "16px",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: "8px",
//                   backgroundColor: "#fff",
//                   boxSizing: "border-box",
//                   outline: "none",
//                 }}
//               />
//             </div>
//           </div>

//           {/* Email */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "8px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 color: "#64748b",
//                 textTransform: "uppercase",
//               }}
//             >
//               Email Address
//             </label>

//             <div style={{ position: "relative" }}>
//               <Mail
//                 size={16}
//                 color="#94a3b8"
//                 style={{
//                   position: "absolute",
//                   left: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                 }}
//               />

//               <input
//                 type="email"
//                 value={formData.email}
//                 onChange={(e) =>
//                   handleChange("email", e.target.value)
//                 }
//                 placeholder="name@company.com"
//                 required
//                 style={{
//                   width: "100%",
//                   height: "44px",
//                   paddingLeft: "40px",
//                   paddingRight: "16px",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: "8px",
//                   backgroundColor: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//           </div>

//           {/* Company */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "8px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 color: "#64748b",
//                 textTransform: "uppercase",
//               }}
//             >
//               Company Name
//             </label>

//             <div style={{ position: "relative" }}>
//               <Building
//                 size={16}
//                 color="#94a3b8"
//                 style={{
//                   position: "absolute",
//                   left: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                 }}
//               />

//               <input
//                 type="text"
//                 value={formData.company}
//                 onChange={(e) =>
//                   handleChange("company", e.target.value)
//                 }
//                 placeholder="Acme Enterprise"
//                 required
//                 style={{
//                   width: "100%",
//                   height: "44px",
//                   paddingLeft: "40px",
//                   paddingRight: "16px",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: "8px",
//                   backgroundColor: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//           </div>

//           {/* Password */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "8px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 color: "#64748b",
//                 textTransform: "uppercase",
//               }}
//             >
//               Password
//             </label>

//             <div style={{ position: "relative" }}>
//               <Lock
//                 size={16}
//                 color="#94a3b8"
//                 style={{
//                   position: "absolute",
//                   left: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                 }}
//               />

//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={formData.password}
//                 onChange={(e) =>
//                   handleChange("password", e.target.value)
//                 }
//                 required
//                 style={{
//                   width: "100%",
//                   height: "44px",
//                   paddingLeft: "40px",
//                   paddingRight: "45px",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: "8px",
//                   backgroundColor: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />

//               <button
//                 type="button"
//                 onClick={() =>
//                   setShowPassword(!showPassword)
//                 }
//                 style={{
//                   position: "absolute",
//                   right: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   border: "none",
//                   background: "transparent",
//                   cursor: "pointer",
//                 }}
//               >
//                 {showPassword ? (
//                   <EyeOff size={16} />
//                 ) : (
//                   <Eye size={16} />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Confirm Password */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "8px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 color: "#64748b",
//                 textTransform: "uppercase",
//               }}
//             >
//               Confirm Password
//             </label>

//             <input
//               type={showPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={(e) =>
//                 handleChange(
//                   "confirmPassword",
//                   e.target.value
//                 )
//               }
//               required
//               style={{
//                 width: "100%",
//                 height: "44px",
//                 paddingLeft: "16px",
//                 paddingRight: "16px",
//                 border: "1px solid #e2e8f0",
//                 borderRadius: "8px",
//                 backgroundColor: "#fff",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>

//           {/* Terms */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               <input type="checkbox" required />

//               <span
//                 style={{
//                   fontSize: "11px",
//                   color: "#64748b",
//                 }}
//               >
//                 I accept the Terms and Privacy Policy
//               </span>
//             </label>
//           </div>

//           {/* Submit */}
//           <button
//             type="submit"
//             style={{
//               width: "100%",
//               height: "44px",
//               backgroundColor: "#000",
//               color: "#fff",
//               border: "none",
//               borderRadius: "8px",
//               cursor: "pointer",
//               fontWeight: "bold",
//               textTransform: "uppercase",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "8px",
//             }}
//           >
//             Execute Registration
//             <ArrowRight size={16} />
//           </button>
//         </form>
//       </main>
//     </div>
//   );
// }

// export default SignupScreen;


import React, { useState } from "react";
import axios from "axios";
import {
  Cloud,
  Mail,
  Lock,
  User,
  Building,
  Eye,
  EyeOff,
  ArrowRight,
  Phone,
  Upload,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import A1 from '../Images/elo.png';
import ReCAPTCHA from 'react-google-recaptcha';

function SignupScreen({ onSwitchToLogin }) {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    company_name: "",
    company_logo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "company_logo") {
      setFormData((prev) => ({
        ...prev,
        company_logo: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      username,
      mobile,
      email,
      password,
      confirmPassword,
      company_name,
      company_logo,
    } = formData;

    if (password !== confirmPassword) {
      alert("Passwords don't match!");
      return;
    }

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("username", username);
      formDataToSend.append("mobile", mobile);
      formDataToSend.append("email", email);
      formDataToSend.append("password", password);
      formDataToSend.append("company_name", company_name);

      if (company_logo) {
        formDataToSend.append("company_logo", company_logo);
      }

      const response = await axios.post(
        "https://cloudapi.emedhatechnologies.com/auth/api/Signup",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        alert(response.data.message);

        setFormData({
          username: "",
          mobile: "",
          email: "",
          password: "",
          confirmPassword: "",
          company_name: "",
          company_logo: null,
        });

        navigate("/verification");
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.error);
      } else if (error.request) {
        alert("Failed to send request to server.");
      } else {
        alert("Something went wrong. Please try again.");
      }

      console.error(error);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f8fafc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "24px",
        fontFamily: "monospace",
        color: "#0f172a",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              // backgroundColor: "#000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <Cloud size={20} color="#fff" /> */}
              <img src={A1} alt='Logo' style={{ height: '40px', marginBottom: '20px' }} />
          </div>
{/* 
          <span
            style={{
              fontWeight: "bold",
              fontSize: "12px",
              textTransform: "uppercase",
              letterSpacing: "2px",
            }}
          >
            Cloud Connect
          </span> */}
        </div>

        <div
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
          }}
        >
          <span
            style={{
              color: "#94a3b8",
              marginRight: "5px",
            }}
          >
            Have an account?
          </span>

          <button
           // onClick={onSwitchToLogin}
             onClick={() => navigate('/')}
            style={{
              border: "none",
              background: "transparent",
              fontWeight: "bold",
              cursor: "pointer",
              color: "#000",
            }}
          >
            Sign In
          </button>
        </div>
      </header>

      {/* Main Form */}
      <main
        style={{
          width: "100%",
          maxWidth: "400px",
          margin: "40px auto",
        }}
      >
        <div style={{ marginBottom: "32px" }}>
          <h1
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "2px",
              marginBottom: "8px",
            }}
          >
            Create Account
          </h1>

          <p
            style={{
              color: "#94a3b8",
              fontSize: "12px",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Begin Node Infrastructure Setup
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Username */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Username
            </label>

            <div style={{ position: "relative" }}>
              <User
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>

          {/* Mobile */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Mobile Number
            </label>

            <div style={{ position: "relative" }}>
              <Phone
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>

          {/* Email */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Email Address
            </label>

            <div style={{ position: "relative" }}>
              <Mail
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>

          {/* Company Name */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Company Name
            </label>

            <div style={{ position: "relative" }}>
              <Building
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>

          {/* Company Logo */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Company Logo
            </label>

            <div style={{ position: "relative" }}>
              <Upload
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type="file"
                name="company_logo"
                accept="image/*"
                onChange={handleChange}
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  paddingTop: "10px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  boxSizing: "border-box",
                }}
              />
            </div>
          </div>

          {/* Password */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Password
            </label>

            <div style={{ position: "relative" }}>
              <Lock
                size={16}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  height: "44px",
                  paddingLeft: "40px",
                  paddingRight: "45px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#64748b",
                textTransform: "uppercase",
              }}
            >
              Confirm Password
            </label>

            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                height: "44px",
                padding: "0 16px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
              }}
            />
          </div>
 <div style={{ marginBottom: '15px' }}><ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" /></div>
          <button
            type="submit"
            style={{
              width: "100%",
              height: "44px",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              textTransform: "uppercase",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
            }}
          >
            Execute Registration
            <ArrowRight size={16} />
          </button>
        </form>
      </main>
    </div>
  );
}

export default SignupScreen;